import { Inject, Injectable } from '@angular/core';
import { Tile, TileFromApi } from './tile';
import { Observable, ReplaySubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map, shareReplay, tap } from 'rxjs/operators';

class TilesApiCall {
  callingApi: boolean;
  tilesSubject$: ReplaySubject<Tile[]>;

  constructor() {
    this.callingApi = false;
    this.tilesSubject$ = new ReplaySubject<Tile[]>(1);
  }
}

@Injectable({
  providedIn: 'root',
})
export class TileService {
  private tilesApiCallByCategory: Map<string, TilesApiCall> = new Map();
  private tilesKey = 'vignettes';

  constructor(@Inject('EnvironmentProvider') private environmentProvider, private httpClient: HttpClient) {}

  loadTiles(contactUsType: string): Observable<Tile[]> {
    if (!this.tilesApiCallByCategory.get(contactUsType)) {
      this.tilesApiCallByCategory.set(contactUsType, new TilesApiCall());
    }

    if (this.tilesApiCallByCategory.get(contactUsType).callingApi) {
      return this.tilesApiCallByCategory.get(contactUsType).tilesSubject$;
    }
    this.tilesApiCallByCategory.get(contactUsType).callingApi = true;

    return this.httpClient.get(`${this.environmentProvider.api.tile}/${contactUsType}`).pipe(
      map((response) =>
        Object.values(response[this.tilesKey]).map((tileFromApi: TileFromApi) => new Tile(tileFromApi))
      ),
      shareReplay(),
      tap((tiles) => this.tilesApiCallByCategory.get(contactUsType).tilesSubject$.next(tiles))
    );
  }
}
